export default __webpack_public_path__ + "static/media/nanga-parbat.e4f75da8.jpg";